const { z } = require('zod');

const brandSchema = z.enum(['today', 'nbcnews']);

/** @typedef {z.infer<typeof brandSchema>} Brand */

/**
 * @typedef {{
 *   oneTimeCode: string;
 *   bedrockSession: string;
 *   email: string;
 *   brand: Brand;
 * }} DeleteProfileRequestBody
 */

/**
 * @template T
 * @typedef {{
 *   success: true;
 *   data: T;
 * } | {
 *   success: false;
 *   error: any;
 * }} BedrockApiResponse<T>
 */

/**
 * User Preferences, as stored in Bedrock
 *
 * @typedef {{
 *  brand: string;
 *  category: "settings" | "preferences" | "alerts";
 *  values: Partial<{
 *    contentInterests: string;
 *  }>;
 * }} BedrockPreferences
 */

/**
 * Preferences for a user - these come from bedrock, but are transformed for easier use in the app
 * @typedef {{
 *  brand: string;
 *  category: "settings" | "preferences" | "alerts";
 *  values: Partial<{
 *    contentInterests: string[];
 *  }>;
 * }} UserPreferences
 */

module.exports = {
  brandSchema,
};
